import type { ReactNode } from 'react';

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ kicker, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="w-5 h-[3px] rounded-full bg-primary-600" />
          <span className="text-[12px] font-semibold tracking-widest text-primary-700 uppercase">
            {kicker}
          </span>
        </div>
        <h2 className="font-heading text-[22px] md:text-[30px] font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 text-[13px] md:text-[14px] text-foreground-600 max-w-[620px] leading-relaxed">
            {desc}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}